// Порядок мероприятий в списке выбора (справочник 25 «МЗЛ»).
//
// В справочнике 84 записи, и самые частые лежат в середине и в конце: до ЛПО и
// санитарных рубок приходилось прокручивать почти весь список. Поэтому они
// подняты наверх — в том порядке, который назвали методисты. Сам справочник не
// меняется: это только порядок показа.

export const MEASURES_HANDBOOK_ID = 25;

//: Коды частых мероприятий, в нужном порядке.
export const PRIORITY_MEASURE_CODES = ['370', '371', '511', '534', '512'];

const codeOf = (reference) => String(reference && reference.code);

/** Частые мероприятия — первыми и в заданном порядке, остальные следом как были. */
export const orderMeasures = (references) => {
  const list = Array.isArray(references) ? references : [];
  const priority = PRIORITY_MEASURE_CODES
    .map((code) => list.find((reference) => codeOf(reference) === code))
    .filter(Boolean);
  const rest = list.filter((reference) => !priority.includes(reference));
  return [...priority, ...rest];
};

/** Сколько частых мероприятий нашлось в справочнике — столько первых строк списка. */
export const priorityCount = (references) =>
  PRIORITY_MEASURE_CODES.filter((code) =>
    (Array.isArray(references) ? references : []).some((reference) => codeOf(reference) === code),
  ).length;
